import React from 'react';
import styled from 'styled-components';

import PillLabel from '@ui/labels/PillLabel.tsx';

import { useCSSColors } from '../../hooks/useCSSColors.ts';

const StyledPillLabel = styled(PillLabel)`
  padding: 2px 4px;
  text-transform: none;
`;

interface SecuritySmallLabelProps {
  dynamicData?: { isTemporarilyClosed?: boolean };
  T: (key: string) => string;
  className?: string;
  statusText?: string;
}

const SecuritySmallLabel = ({ dynamicData, className, statusText }: SecuritySmallLabelProps) => {
  const colors = useCSSColors();

  if (!dynamicData) {
    return null;
  }

  const { isTemporarilyClosed } = dynamicData;

  const backgroundColor = isTemporarilyClosed ? colors.statusClosedBackground : colors.statusCancelledBackground;

  const color = isTemporarilyClosed ? colors.statusClosedText : colors.statusCancelledText;

  return (
    <StyledPillLabel $backgroundColor={backgroundColor} $color={color} className={className}>
      {statusText}
    </StyledPillLabel>
  );
};

export { SecuritySmallLabel };
